import React, {createContext, useReducer} from 'react'

export const SET_WIRE_LIST = 'SET_WIRE_LIST'
export const SELECT_WIRE = 'SELECT_WIRE'
export const SET_SHOW_WIRE_POPUP = 'SET_SHOW_WIRE_POPUP'

const Reducer = (data, payload) => {
  switch (payload.type) {
    case SET_WIRE_LIST:
      return { ...data, wire_list: payload.data }
    case SELECT_WIRE:
      return {
        ...data,
        selected_wire: payload.data.selected_wire,
        show_wire_popup: payload.data.show_wire_popup,
      }
    case SET_SHOW_WIRE_POPUP:
      return {
        ...data,
        show_wire_popup: payload.data,
        selected_wire: payload.data ? data.selected_wire : {},
      }
    default:
      return data
  }
}

const initialState = {
  wire_list: [],
  selected_wire: {},
  show_wire_popup: false,
}

const WireStore = ({ children }) => {
  const [state, dispatch] = useReducer(Reducer, initialState)

  return (
    <WireContext.Provider value={[state, dispatch]}>
      {children}
    </WireContext.Provider>
  )
}

export const WireContext = createContext(initialState)
export default WireStore
